import { Fragment } from "react";
import React from "react";
import { Transition } from "@headlessui/react";
import {Navigate } from "react-router-dom";
import {
  XIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
} from "@heroicons/react/solid";
import axios from "axios";



class SettingPageedit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      success: false,
      redirect: false,
      editID: this.props.editID,
      ListtoEdit: this.props.ListtoEdit,
      error_list: [],
      updateButton: false,
      name:"",
      house_number:"",
    };
    this.handleInputName = this.handleInputName.bind(this);
  }
  async componentDidMount() {
  }
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    
    this.setState({ sidebarOpen: true });
  };
  handleInputName = (e, index) => {
    this.state.name = e.target.value;
    this.state.house_number = e.target.value;
    this.state.ListtoEdit[index].data = e.target.value;
    this.setState({ ListtoEdit: this.state.ListtoEdit });
  };

  handleInputwarehouseF = (e) => {
    this.props.handleInputwarehouseAE(e);
  };

  saveItem = async (e) => {
   
    this.state.name=this.state.ListtoEdit[0].data;
   this.setState({ name: this.state.name });
   this.state.house_number=this.state.ListtoEdit[0].data;
   this.setState({ house_number: this.state.house_number });
    e.preventDefault();
    let url = "";
    this.state.ListtoEdit.map(
      (item) => ((url = item.url), this.setState({ name: item.name ,house_number: item.house_number }))
    );
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post(
      url + "/" + this.state.editID,

      this.state,
      {
        headers,
      }
    );

    if (res.data.success) {
      this.setState({ showmsg: true });
      this.handleInputwarehouseF(res.data.success);
      this.setState({name:""});
      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };
  componentDidMount() {
    let token = localStorage.getItem("token");
  }
  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    if (res.data.success) {
      localStorage.removeItem("token");
      this.setState({ logoutRedirect: true }); 
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}

        <main className="flex-1">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {this.state.ListtoEdit.map((item,index) => (
                <h1 key={index} className="text-2xl font-semibold text-gray-900">
                  {item.heading}
                </h1>
              ))}
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-6">
              {/* Replace with your content */}

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>
              <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                <div className="md:grid md:gap-6">
                  <div className="mt-5 md:mt-0 md:col-span-2">
                    <form onSubmit={this.saveItem}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            {this.state.ListtoEdit.map((item, index) => (
                              <div key={index} className="col-span-6 sm:col-span-6 lg:col-span-3">
                                <label
                                  htmlFor={item.label}
                                  className="block text-sm font-medium text-gray-700"
                                >
                                  {item.label}
                                </label>
                                <input
                                  type={item.type}
                                  name={item.name}
                                  id={item.name}
                                  value={item.data}
                                  onChange={(evt) =>
                                    this.handleInputName(evt, index)
                                  }
                                  className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md "
                                />
                                <p
                                  className="mt-2 text-sm text-red-600"
                                  id="warehouse_name-error"
                                >
                                  {this.state.error_list.name}
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="px-4 py-3 bg-gray-50 text-center sm:px-6">
                          <button
                            type="submit"
                            disabled={this.state.updateButton}
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* /End replace */}
            </div>
          </div>
        </main>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default SettingPageedit;
